// extracted by mini-css-extract-plugin
module.exports = {"loginButton":"LoginButton_loginButton__1sRd4","buttonText":"LoginButton_buttonText__3mNdM"};